import { Loadable } from 'utils/components';
import { PRICING_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'PricingPage' */ './components/PricingPage')
  })
};
